import { render, staticRenderFns } from "./PinModal.vue?vue&type=template&id=64a0894c"
import script from "./PinModal.vue?vue&type=script&lang=js"
export * from "./PinModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports